var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',{staticClass:"contain"},[_c('v-btn',{staticClass:"button-exam",attrs:{"elevation":"6","to":"/exam/information","large":"","x-large":"","x-small":""}},[_vm._v(" Thêm đề thi ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }